import React from 'react'
import { get } from 'lodash-es'
import { Helmet } from 'react-helmet'
import { Redirect, RouteComponentProps } from 'react-router-dom'
import logo from '../../../../theme/images/logo.svg'
import { Card, Layout, LayoutHeader, LayoutBody, LoginForm } from '../../../components'
import styles from './LoginPage.module.scss'

interface LoginPageProps {
  isAuthenticated: boolean
  location?: RouteComponentProps['location']
  redirect: (path: string) => void
  passwordReset?: boolean
  hasSessionTimedOut?: boolean
}

const LoginPage = (props: LoginPageProps) => {
  const from = get(props, 'location.state.from', '/dashboard')
  return props.isAuthenticated ? (
    <Redirect to={from} />
  ) : (
    <div className={styles.root}>
      <Helmet>
        <title>reOS | Login</title>
      </Helmet>
      <Layout>
        <LayoutHeader>
          <div className={styles.header}>
            <img width="96px" src={logo} alt="reOS" />
          </div>
        </LayoutHeader>
        <LayoutBody>
          <div className={styles['form-container']}>
            <div style={{ width: '360px' }}>
              {props.hasSessionTimedOut && (
                <p style={{ textAlign: 'center' }}>Your session timed out, please login to continue.</p>
              )}
              <Card on style={{ width: '360px' }}>
                <LoginForm passwordReset={!!props.passwordReset} />
              </Card>
              <p className={styles.footer}>
                <button type="button" onClick={() => props.redirect('/forgot')}>
                  Forgot password?
                </button>
                {/* <button type="button" onClick={() => props.redirect('/user-signup')}>
                  Request access.
                </button> */}
              </p>
            </div>
          </div>
        </LayoutBody>
      </Layout>
    </div>
  )
}

export default LoginPage
